

import Vue from 'vue'
import FastClick from 'fastclick'
import router from './router'
import NProgress from 'nprogress'
import tabBar from '@/components/tabBar'
import consult from '@/components/consult'
import Group from 'vux/src/components/group/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Sticky from 'vux/src/components/sticky/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import DatetimePlugin from 'vux/src/plugins/datetime/index.js'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Picker from 'vux/src/components/picker/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

import App from './App'
import '@/styles/theme.less' 
import '@/styles/index.less' 
import 'nprogress/nprogress.css' 
import store from './store'
import MetaInfo from 'vue-meta-info'
import Navigation from 'vue-navigation'
import VueTouch from 'vue-touch'
FastClick.attach(document.body)

Vue.config.productionTip = false

Vue.component('consult', consult)
Vue.component('tab-bar', tabBar)

Vue.component('group', Group)
Vue.component('tab', Tab)
Vue.component('tab-item', TabItem)
Vue.component('sticky', Sticky)
Vue.component('x-button', XButton)
Vue.component('swiper', Swiper)
Vue.component('tabbar', Tabbar)
Vue.component('tabbar-item', TabbarItem)
Vue.component('popup-picker', PopupPicker)
Vue.component('picker', Picker)
Vue.component('previewer', Previewer)
Vue.component('x-dialog', XDialog)
Vue.component('icon', Icon)
Vue.component('load-more', LoadMore)
Vue.component('scroller', Scroller)
Vue.component('popup', Popup)
Vue.component('swiper-item', SwiperItem)


NProgress.inc(0.2)
NProgress.configure({ easing: 'ease', speed: 500, showSpinner: false })

router.beforeEach((to, from, next) => {
NProgress.start()

store.commit('dict/setLoginBackFullPath', from.fullPath)

if (!store.getters['dict/dictData'] || !store.getters['dict/dictData'].region) {
store.dispatch('user/getUserInfoAction').then(() => {
const dictData = JSON.parse(window.localStorage.getItem('dictData'))
const locationInfo = JSON.parse(window.localStorage.getItem('locationInfo'))
if (dictData && locationInfo && to.path !== '/h5' && to.path !== '/h5/index') {
store.commit('dict/setDictData', dictData)
store.commit('dict/setLocationInfo', locationInfo)
if ((store.getters['user/userInfo'] && store.getters['user/userInfo'].loginName) && (to.path === '/h5/login' || to.path === '/h5/regist' || to.path === '/h5/forget')) {
next('/h5')
} else {
next()
}
} else {
store.dispatch('dict/dictDataAction').then(() => {

store.dispatch('dict/locationInfoAction')
if ((store.getters['user/userInfo'] && store.getters['user/userInfo'].loginName) && (to.path === '/h5/login' || to.path === '/h5/regist' || to.path === '/h5/forget')) {
next('/h5')
} else {
next()
}
}).catch(() => {
next()
})
}
}).catch(() => {
next()
})
} else {
if ((store.getters['user/userInfo'] && store.getters['user/userInfo'].loginName) && (to.path === '/h5/login' || to.path === '/h5/regist' || to.path === '/h5/forget')) {
next('/h5')
} else {
next()
}
}
})

router.afterEach(() => {
NProgress.done()
})


Vue.use(AlertPlugin)
Vue.use(ToastPlugin)
Vue.use(ConfirmPlugin)
Vue.use(DatetimePlugin)
Vue.use(LoadingPlugin)
Vue.use(MetaInfo)
Vue.use(Navigation, {router, store, moduleName: 'navigation', keyName: 'VIEW_KEY'})
Vue.use(VueTouch, {name: 'v-touch'})
Vue.prototype.$alert = function (title, msg) {
this.$vux.alert.show({
title: title,
content: msg
})
}

Vue.prototype.$toast = function (title) {
this.$vux.toast.text(title, 'middle')
}

/* eslint-disable no-new */
let app = new Vue({
router,
store,
render: h => h(App)
}).$mount('#app-box')

export default app



// WEBPACK FOOTER //
// ./src/main.js